import React from 'react'
import {
    Grid,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography
} from '@material-ui/core'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'


export default function PhoneValidation({ open = false, setOpen = () => { }, phone, setPhone = () => { }, sendOTP = () => { }, codeSent, code, setCode = () => { }, validateOTP = () => { }, error, recapchaRef }) {

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <Dialog
            open={open}
            onClose={() => { }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{`Valide su teléfono`}</DialogTitle>
            <DialogContent style={{ paddingBottom: 50 }}>
                <Grid contanier>
                    <Grid item xs={12}>
                        <PhoneInput
                            country={'uy'}
                            value={phone}
                            onChange={phone => setPhone(phone)}
                            onlyCountries={['uy']}
                            areaCodes={{ uy: ['+598'] }}
                            disabled={codeSent}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <div id="recaptcha-phone"></div>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <Button onClick={sendOTP} variant="outlined" color="primary" fullWidth>{codeSent ? 'Reenviar código' : 'Enviar código'}</Button>
                    </Grid>
                    {
                        codeSent &&
                        <>
                            <Grid item xs={12} style={{ marginTop: 10 }}>
                                <TextField
                                    type="number"
                                    value={code}
                                    onChange={e => setCode(e.target.value)}
                                    variant="outlined"
                                    label="Ingrese código"
                                    placeholder='Ingrese el código enviado a su celular'
                                    size='small'
                                    fullWidth
                                    disabled={!codeSent}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 10 }}>
                                <Button
                                    onClick={validateOTP}
                                    variant="outlined"
                                    fullWidth
                                    style={{ color: "#007a10" }}
                                    disabled={!codeSent}
                                >
                                    Verificar código
                                </Button>
                            </Grid>
                        </>
                    }

                    <Grid item xs={12} style={{ marginTop: 20 }}>
                        <Typography color="error">{error}</Typography>
                    </Grid>
                </Grid>


            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
